module.exports = __webpack_public_path__ + "ee68c5330c1d8b7e02dbb1afadb6f341.pdf";